import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from '@leandredev/common_ng_14';
import { DayjsModule } from '@leandredev/common_ng_14';
import { ActUiListComponent } from './Act.component';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [ActUiListComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatPaginatorModule,
    SharedModule,
    DayjsModule
  ],
  exports: [
    ActUiListComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    SharedModule,
    DayjsModule,
    PipesModule
  ]
})
export class ActListModule {}
